import deepSet from '@/helpers/deep-set'
import valuesManager from '@/theme/valuesManager'

export default {
  namespaced: true,

  state: {
    pages_presence: {
      about_us: valuesManager.getBooleanValue('pages_presence.about_us'),
      delivery_and_payment: valuesManager.getBooleanValue('pages_presence.delivery_and_payment'),
      blog: valuesManager.getBooleanValue('pages_presence.blog'),
      offers: valuesManager.getBooleanValue('pages_presence.offers'),
      legal_profile: valuesManager.getBooleanValue('pages_presence.legal_profile'),
    },

    products: {
      display_description: valuesManager.getBooleanValue('products.display_description'),
      display_variant_option_label: valuesManager.getRequiredValue('products.display_variant_option_label'),
      cart_button_visibility: valuesManager.getRequiredValue('products.cart_button_visibility'),
      cart_button_available: valuesManager.getRequiredValue('products.cart_button_available'),
      cart_button_unavailable: valuesManager.getRequiredValue('products.cart_button_unavailable'),
      card_image_aspect_ratio: valuesManager.getRequiredValue('products.card_image_aspect_ratio'),
      card_image_object_fit: valuesManager.getRequiredValue('products.card_image_object_fit'),
      card_shadow_size: valuesManager.getRequiredValue('products.card_shadow_size'),
      card_shadow_opacity: valuesManager.getRequiredValue('products.card_shadow_opacity'),
      card_hover_shadow_size: valuesManager.getRequiredValue('products.card_hover_shadow_size'),
      card_hover_shadow_opacity: valuesManager.getRequiredValue('products.card_hover_shadow_opacity'),
      card_border_width: valuesManager.getRequiredValue('products.card_border_width'),
      cards_count_desktop: parseInt(valuesManager.getRequiredValue('products.cards_count_desktop'), 10),
      modifiers_visibility: valuesManager.getRequiredValue('products.modifiers_visibility'),
      display_nested_categories: valuesManager.getRequiredValue('products.display_nested_categories'),
    },

    appbars: {
      desktop_variant: valuesManager.getRequiredValue('appbars.desktop_variant'),
      mobile_variant: valuesManager.getRequiredValue('appbars.mobile_variant'),
      disable_mobile_specific_appbar: valuesManager.getBooleanValue('appbars.disable_mobile_specific_appbar'),
    },

    sidebar: {
      fixed: valuesManager.getRequiredValue('sidebar.fixed'),
      variant: valuesManager.getRequiredValue('sidebar.variant')
    },

    search: {
      placeholder: valuesManager.getRequiredValue('search.placeholder'),
    },

    logos: {
      header: valuesManager.getRequiredValue('logos.header'),
      footer: valuesManager.getRequiredValue('logos.footer'),
      favicon: valuesManager.getRequiredValue('logos.favicon'),
    },

    seo: {
      include_store_name: valuesManager.getRequiredValue('seo.include_store_name'),
      title_divider: valuesManager.getRequiredValue('seo.title_divider'),
      og_image: valuesManager.getRequiredValue('seo.og_image'),
    },

    delivery: {
      restrict_to_city: valuesManager.getBooleanValue('delivery.restrict_to_city'),
      extra_address_fields_state: valuesManager.getRequiredValue('delivery.extra_address_fields_state'),
      notes_field_state: valuesManager.getRequiredValue('delivery.notes_field_state'),
      address_hint: valuesManager.getRequiredValue('delivery.address_hint'),
    },

    yandex_metrika: {
      yandex_metrika_id: valuesManager.getValue('yandex_metrika.yandex_metrika_id'),
      yandex_metrika_webvisor: valuesManager.getBooleanValue('yandex_metrika.yandex_metrika_webvisor'),
      yandex_metrika_ecommerce: valuesManager.getBooleanValue('yandex_metrika.yandex_metrika_ecommerce'),
    },

    facebook_pixel: {
      id: valuesManager.getValue('facebook_pixel.id'),
    },

    vk_pixel: {
      id: valuesManager.getValue('vk_pixel.id'),
    },

    feedback_form: {
      name_enabled: valuesManager.getBooleanValue('feedback_form.name_enabled'),
      message_enabled: valuesManager.getBooleanValue('feedback_form.message_enabled'),
      contact_type: valuesManager.getRequiredValue('feedback_form.contact_type'),
    },

    legal_docs: {
      privacy_policy: valuesManager.getBooleanValue('legal_docs.privacy_policy'),
      personal_data: valuesManager.getBooleanValue('legal_docs.personal_data'),
      personal_data_agreement: valuesManager.getBooleanValue('legal_docs.personal_data_agreement'),
      eula: valuesManager.getBooleanValue('legal_docs.eula'),
    },

    orders: {
      thank_you_title: valuesManager.getRequiredValue('orders.thank_you_title'),
      thank_you_text: valuesManager.getRequiredValue('orders.thank_you_text'),
      thank_you_image: valuesManager.getRequiredValue('orders.thank_you_image'),
      checkout_enabled: valuesManager.getBooleanValue('orders.checkout_enabled'),
    },

    home_seo: {
      title: valuesManager.getRequiredValue('home_seo.title'),
      description: valuesManager.getRequiredValue('home_seo.description'),
      og_image: valuesManager.getRequiredValue('home_seo.og_image'),
    },

    home_promo: {
      visibility: valuesManager.getRequiredValue('home_promo.visibility'),
      heading: valuesManager.getRequiredValue('home_promo.heading'),
      subheading: valuesManager.getRequiredValue('home_promo.subheading'),
      background: valuesManager.getRequiredValue('home_promo.background'),
      promo_button: valuesManager.getRequiredValue('home_promo.promo_button'),
      promo_button_visibility: valuesManager.getRequiredValue('home_promo.promo_button_visibility'),
    },

    home_features: {
      visibility: valuesManager.getRequiredValue('home_features.visibility'),
      order: valuesManager.getRequiredValue('home_features.order'),
      list: valuesManager.getRequiredValue('home_features.list'),
    },

    home_offers: {
      visibility: valuesManager.getRequiredValue('home_offers.visibility'),
      order: valuesManager.getRequiredValue('home_offers.order'),
      variant: valuesManager.getRequiredValue('home_offers.variant'),
      subvariant: valuesManager.getRequiredValue('home_offers.subvariant'),
      full_width_variant_card_size: valuesManager.getRequiredValue('home_offers.full_width_variant_card_size'),
      display_text: valuesManager.getBooleanValue('home_offers.display_text'),
      image_aspect_ratio_width: valuesManager.getRequiredValue('home_offers.image_aspect_ratio_width'),
      image_aspect_ratio_height: valuesManager.getRequiredValue('home_offers.image_aspect_ratio_height'),
      image_brightness_percent: valuesManager.getRequiredValue('home_offers.image_brightness_percent'),
      title: valuesManager.getRequiredValue('home_offers.title'),
      subtitle: valuesManager.getRequiredValue('home_offers.subtitle'),
      sorting: valuesManager.getRequiredValue('home_offers.sorting'),
    },

    home_categories: {
      visibility: valuesManager.getRequiredValue('home_categories.visibility'),
      order: valuesManager.getRequiredValue('home_categories.order'),
      categories_to_display_select: valuesManager.getRequiredValue('home_categories.categories_to_display_select'),
      categories_list: valuesManager.getRequiredValue('home_categories.categories_list'),
      display_names: valuesManager.getRequiredValue('home_categories.display_names'),
    },

    home_products_collection: {
      visibility: valuesManager.getRequiredValue('home_products_collection.visibility'),
      order: valuesManager.getRequiredValue('home_products_collection.order'),
      collection_id: valuesManager.getValue('home_products_collection.collection_id'),
      title: valuesManager.getRequiredValue('home_products_collection.title'),
      count: parseInt(valuesManager.getRequiredValue('home_products_collection.count'), 10) || -1,
    },

    home_feedback: {
      visibility: valuesManager.getRequiredValue('home_feedback.visibility'),
      order: valuesManager.getRequiredValue('home_feedback.order'),
      title: valuesManager.getRequiredValue('home_feedback.title'),
      content: valuesManager.getRequiredValue('home_feedback.content'),
      label: valuesManager.getRequiredValue('home_feedback.label'),
    },

    about_us_seo: {
      title: valuesManager.getRequiredValue('about_us_seo.title'),
      description: valuesManager.getRequiredValue('about_us_seo.description'),
      og_image: valuesManager.getRequiredValue('about_us_seo.og_image'),
    },

    about_us_menu: {
      title: valuesManager.getRequiredValue('about_us_menu.title'),
    },

    about_us_promo: {
      display: valuesManager.getBooleanValue('about_us_promo.display'),
      background: valuesManager.getRequiredValue('about_us_promo.background'),
      background_gradient: valuesManager.getBooleanValue('about_us_promo.background_gradient'),
      without_context_background: valuesManager.getBooleanValue('about_us_promo.without_context_background'),
      title: valuesManager.getRequiredValue('about_us_promo.title'),
      content: valuesManager.getRequiredValue('about_us_promo.content'),
    },

    about_us_cards: {
      display: valuesManager.getBooleanValue('about_us_cards.display'),
      icon: valuesManager.getRequiredValue('about_us_cards.icon'),
      title: valuesManager.getRequiredValue('about_us_cards.title'),
      list: valuesManager.getRequiredValue('about_us_cards.list')
    },

    about_us_technology: {
      display: valuesManager.getBooleanValue('about_us_technology.display'),
      background: valuesManager.getRequiredValue('about_us_technology.background'),
      size: 'half',
      heading: valuesManager.getRequiredValue('about_us_technology.heading'),
      icon: valuesManager.getRequiredValue('about_us_technology.icon'),
      title: valuesManager.getRequiredValue('about_us_technology.title'),
      description: valuesManager.getRequiredValue('about_us_technology.description'),
      list: valuesManager.getRequiredValue('about_us_technology.list'),
    },

    about_us_staff: {
      display: valuesManager.getBooleanValue('about_us_staff.display'),
      size: 'full',
      heading: valuesManager.getRequiredValue('about_us_staff.heading'),
      subheading: valuesManager.getRequiredValue('about_us_staff.subheading'),
      icon: valuesManager.getRequiredValue('about_us_staff.icon'),
      list: valuesManager.getRequiredValue('about_us_staff.list')
    },

    about_us_quality: {
      display: valuesManager.getBooleanValue('about_us_quality.display'),
      size: 'half',
      title: valuesManager.getRequiredValue('about_us_quality.title'),
      description: valuesManager.getRequiredValue('about_us_quality.description'),
      image: valuesManager.getRequiredValue('about_us_quality.image'),
      image_position: 'left',
    },

    about_us_feedback: {
      size: 'full',
      display: valuesManager.getBooleanValue('about_us_feedback.display'),
      title: valuesManager.getRequiredValue('about_us_feedback.title'),
      content: valuesManager.getRequiredValue('about_us_feedback.content'),
      label: valuesManager.getRequiredValue('about_us_feedback.label'),
    },

    blog_list: {
      title: valuesManager.getRequiredValue('blog_list.title'),
    },

    blog_seo: {
      title: valuesManager.getRequiredValue('blog_seo.title'),
      description: valuesManager.getRequiredValue('blog_seo.description'),
      og_image: valuesManager.getRequiredValue('blog_seo.og_image'),
    },

    blog_menu: {
      title: valuesManager.getRequiredValue('blog_menu.title'),
    },

    offers_list: {
      title: valuesManager.getRequiredValue('offers_list.title'),
      description: valuesManager.getRequiredValue('offers_list.description'),
    },

    offer_page: {
      display_cover: valuesManager.getRequiredValue('offer_page.display_cover'),
    },

    offers_seo: {
      title: valuesManager.getRequiredValue('offers_seo.title'),
      description: valuesManager.getRequiredValue('offers_seo.description'),
      og_image: valuesManager.getRequiredValue('offers_seo.og_image'),
    },

    offers_menu: {
      title: valuesManager.getRequiredValue('offers_menu.title'),
    },

    delivery_payments_seo: {
      title: valuesManager.getRequiredValue('delivery_payments_seo.title'),
      description: valuesManager.getRequiredValue('delivery_payments_seo.description'),
      og_image: valuesManager.getRequiredValue('delivery_payments_seo.og_image'),
    },

    delivery_payments_menu: {
      title: valuesManager.getRequiredValue('delivery_payments_menu.title'),
    },

    delivery_payments_delivery: {
      display: valuesManager.getBooleanValue('delivery_payments_delivery.display'),
      display_map: valuesManager.getBooleanValue('delivery_payments_delivery.display_map'),
      display_zones: valuesManager.getBooleanValue('delivery_payments_delivery.display_zones'),
      display_stocks: valuesManager.getBooleanValue('delivery_payments_delivery.display_stocks'),
      definitions: valuesManager.getRequiredValue('delivery_payments_delivery.definitions'),
    },

    delivery_payments_payments: {
      display: valuesManager.getBooleanValue('delivery_payments_payments.display'),
      definitions: valuesManager.getRequiredValue('delivery_payments_payments.definitions'),
    },

    delivery_payments_guarantee: {
      display: valuesManager.getBooleanValue('delivery_payments_guarantee.display'),
      definitions: valuesManager.getRequiredValue('delivery_payments_guarantee.definitions'),
    },

    legal_profile_menu: {
      title: valuesManager.getRequiredValue('legal_profile_menu.title'),
    },
  },

  getters: {
    products(state) {
      return state.products
    },

    search(state) {
      return state.search
    },

    delivery(state) {
      return state.delivery
    },

    yandexMetrika(state) {
      return {
        id: state.yandex_metrika.yandex_metrika_id,
        config: {
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          webvisor: state.yandex_metrika.yandex_metrika_webvisor,
          ecommerce: state.yandex_metrika.yandex_metrika_ecommerce,
        },
      }
    },

    facebookPixel(state) {
      return {
        id: state.facebook_pixel.id
      }
    },

    vkPixel(state) {
      return {
        id: state.vk_pixel.id
      }
    },

    feedbackForm(state) {
      return state.feedback_form
    },

    legalDocs(state) {
      return state.legal_docs
    },

    legalDocsLinks(state) {
      const documents = []

      if (state.legal_docs.personal_data) {
        documents.push({
          id: 'personal-data-policy',
          name: 'политикой обработки персональных данных',
          route: { name: 'legal-personal-data-policy' },
        })
      }

      if (state.legal_docs.personal_data_agreement) {
        documents.push({
          id: 'personal-data-policy',
          name: 'согласием на обработку персональных данных',
          route: { name: 'legal-personal-data-agreement' },
        })
      }

      if (state.legal_docs.privacy_policy) {
        documents.push({
          id: 'privacy-policy',
          name: 'политикой конфиденциальности',
          route: { name: 'legal-privacy-policy' },
        })
      }

      if (state.legal_docs.eula) {
        documents.push({
          id: 'eula',
          name: 'пользовательским соглашением',
          route: { name: 'legal-eula' },
        })
      }

      return documents
    },

    orders(state) {
      return state.orders
    },

    searchInputPlaceholder(state, getters) {
      return getters.search.placeholder
    },

    aboutUsSections(state) {
      return {
        promo: state.about_us_promo,
        cards: state.about_us_cards,
        technology: state.about_us_technology,
        staff: state.about_us_staff,
        quality: state.about_us_quality,
        feedback: state.about_us_feedback,
      }
    },

    homeCategories(state) {
      return state.home_categories
    },

    homeSeo(state) {
      return state.home_seo
    },

    homeFeatures(state) {
      return state.home_features.list
    },

    homeOffers(state) {
      return state.home_offers
    },

    homeFeedback(state) {
      return state.home_feedback
    },

    headerLogo(state) {
      return state.logos.header
    },

    footerLogo(state) {
      return state.logos.footer
    },

    favicon(state) {
      return state.logos.favicon
    },

    seo(state) {
      return state.seo
    },

    aboutUsSeo(state) {
      return state.about_us_seo
    },

    aboutUsMenu(state) {
      return state.about_us_menu
    },

    blogList(state) {
      return state.blog_list
    },

    blogSeo(state) {
      return state.blog_seo
    },

    blogMenu(state) {
      return state.blog_menu
    },

    offersList(state) {
      return state.offers_list
    },

    offerPage(state) {
      return state.offer_page
    },

    offersSeo(state) {
      return state.offers_seo
    },

    offersMenu(state) {
      return state.offers_menu
    },

    deliveryPaymentsSeo(state) {
      return state.delivery_payments_seo
    },

    deliveryPaymentsMenu(state) {
      return state.delivery_payments_menu
    },

    deliveryPaymentsDelivery(state) {
      return state.delivery_payments_delivery
    },

    deliveryPaymentsPayments(state) {
      return state.delivery_payments_payments
    },

    deliveryPaymentsGuarantee(state) {
      return state.delivery_payments_guarantee
    },

    legalProfile(state) {
      return state.legal_profile_menu
    },

    mainMenuPresence(state) {
      return state.pages_presence
    },

    mainMenuTitles(state) {
      return {
        about_us: state.about_us_menu.title,
        delivery_and_payment: state.delivery_payments_menu.title,
        blog: state.blog_menu.title,
        offers: state.offers_menu.title,
        legal_profile: state.legal_profile_menu.title,
      }
    },
  },

  mutations: {
    updateSettings(state, { path, value }) {
      deepSet(state, path, valuesManager.getValidatedValue(path, value))
    },
  },

  actions: {
    //
  },
}
